import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAccounts } from "app/services/dashboard/accountService";
import { BASE_URL } from "static/constants";

export const accountApi = createApi({
  reducerPath: "accountApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    fetchAccountList: builder.query({
      queryFn: async () => {
        return { data: await getAccounts() };
      },
    }),
  }),
});

export const { useFetchAccountListQuery } = accountApi;
